import styled from 'styled-components';

export const UiList = styled.a`
	display: flex;
	padding: 6px 0;
	text-decoration: none;

	.label {
		width: 80px;
		height: 30px;
		font-size: 18px;
		text-align: center;
		color: #fff;
		background-color: #EC7963;
		border-radius: 12px;
		line-height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.title {
		margin-left: 16px;
		color: ${({ theme }) => theme.colors.paragraphs};
		line-height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;
